module.exports = __webpack_public_path__ + "media/components/country-flag/static/gw-6241752e14e4af2b1f8c1ea22688e668.svg";